import SpotlightPlayer from './SpotlightPlayer';
import spotlightValidator from './spotlightValidator';
export { spotlightValidator, SpotlightPlayer };
export default SpotlightPlayer;